const styles = {
    radioGroupLabel: {
        fontFamily: 'Silka_Regular',
        fontSize: '14px',
    },
};

export default styles;
